import ApiProcessor from '../../processors/api-processor'
import Status from '../../components/status'
import store from '~/state/store'

const isSuperAdmin = store.getters['me/isSuperAdmin']

const INACTIVE_CELL_STYLE = {
  opacity: 0.4,
}

function cellStyle(status) {
  return status ? {} : INACTIVE_CELL_STYLE
}

const TABLE_FILTERS = [
  {
    attribute: 'status',
    label: 'Status',
    type: 'select',
    icon: 'el-icon-circle-check',
    values: [
      {
        label: 'Active',
        value: 'active',
      },
      {
        label: 'Inactive',
        value: 'inactive',
      },
    ],
  },
  {
    attribute: 'startsAt',
    label: 'Start Date',
    type: 'date',
    icon: 'el-icon-time',
  },
  {
    attribute: 'name',
    label: 'Name',
    type: 'string',
    icon: 'el-icon-document',
  },
  {
    attribute: 'endsAt',
    label: 'End Date',
    type: 'date',
    icon: 'el-icon-time',
  },
  {
    attribute: 'enabled',
    label: 'Enabled',
    type: 'boolean',
    icon: 'el-icon-circle-check',
  },
].filter(v => v)

const TABLE_COLUMNS = [
  {
    name: 'status',
    label: 'Status',
    icon: 'el-icon-circle-check',
    width: 100,
    component: (_, __, { row }) => ({
      is: Status,
      props: {
        status: row.status === 'active',
        inactiveStyle: INACTIVE_CELL_STYLE,
        enabled: row.enabled,
      },
    }),
  },
  isSuperAdmin && {
    name: 'provider.name',
    label: 'Provider',
    icon: 'el-icon-document',
    component: {
      props: {
        styleObj(_, { enabled }) {
          return cellStyle(enabled)
        },
      },
    },
    width: 140,
  },
  {
    name: 'createdAt',
    label: 'Created Date',
    icon: 'el-icon-time',
    format: {
      name: 'date',
      params: ['DD/MM/YYYY'],
    },
    width: 120,
    component: {
      props: {
        styleObj(_, { enabled }) {
          return cellStyle(enabled)
        },
      },
    },
  },
  {
    name: 'startsAt',
    label: 'Starts Date',
    icon: 'el-icon-time',
    format: {
      name: 'date',
      params: ['DD/MM/YYYY'],
    },
    width: 120,
    component: {
      props: {
        styleObj(_, { enabled }) {
          return cellStyle(enabled)
        },
      },
    },
  },
  {
    name: 'name',
    label: 'Name',
    icon: 'el-icon-document',
    width: 200,
    component: {
      props: {
        styleObj(_, { enabled }) {
          return cellStyle(enabled)
        },
      },
    },
  },
  {
    name: 'tags',
    label: 'Tags',
    icon: 'el-icon-document',
    format(_, row) {
      const { tags } = row
      return tags ? tags.join(', ') : ''
    },
    component: {
      props: {
        styleObj(_, { enabled }) {
          return cellStyle(enabled)
        },
      },
    },
  },
  {
    name: 'redemptionLimit',
    label: 'Redemption Limit',
    icon: 'el-icon-document',
    component: {
      props: {
        styleObj(_, { enabled }) {
          return cellStyle(enabled)
        },
      },
    },
  },
  {
    name: 'endsAt',
    label: 'End Date',
    icon: 'el-icon-document',
    format: {
      name: 'date',
      params: ['DD/MM/YYYY'],
    },
    width: 120,
    component: {
      props: {
        styleObj(_, { enabled }) {
          return cellStyle(enabled)
        },
      },
    },
  },
  {
    name: 'enabled',
    label: 'Enabled',
    icon: 'el-icon-circle-check',
    width: 100,
    component: {
      props: {
        styleObj(_, { enabled }) {
          return cellStyle(enabled)
        },
      },
    },
  },
].filter(v => v)

export default component => {
  return {
    processor: new ApiProcessor({
      component,
      path: 'offer-groups',
      initialDataQuery: { pageSize: 25 },
    }),
    filters: TABLE_FILTERS,
    columns: TABLE_COLUMNS,
    tableName: 'offer-groups',
  }
}
